import React from 'react'
import ProfileEdit from '../Components/ProfileEdit/ProfileEdit'

const ProfileEditView = () => {
  return (
    <div>
        <ProfileEdit />
    </div>
  )
}

export default ProfileEditView